import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Modal, Row } from 'antd';
import actions from '../../redux/accounts/actions';
import Input from '../../../components/uielements/input';
import IntlMessages from "../../../components/utility/intlMessages";

const {
  addAccount,
}
  = actions;

const defaultState = {
  name: '',
  error: false,
}

class AddAccountModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...defaultState,
    };
  }
  onNameChange = (event) => {
    const { accounts = [] } = this.props;
    const name = event.target.value;
    const isDuplicate = accounts.filter((account) => account.name ? account.name.toLowerCase() === name.toLowerCase() : false).length > 0;
    return this.setState({
      name,
      error: isDuplicate ? 'Account with this name already exists!' : '',
    });
  }
  closeModal = () => {
    const { showAddAccountModal } = this.props;
    this.setState({
      ...defaultState
    }, showAddAccountModal(false));
  }
  addAccount = () => {
    const { name, error } = this.state;
    const { addAccount } = this.props;
    if (!name) {
      return this.setState({ error: 'Name required!' });
    }
    if (error) return null;
    addAccount({ name });
    return this.closeModal();
  }
  render() {
    const { name, error } = this.state;
    const { visible } = this.props;
    return (

      <Modal
        title={<IntlMessages id="accounts.modal.title" />}
        visible={visible}
        onOk={this.addAccount}
        okText={<IntlMessages id="action.confirm" />}
        onCancel={this.closeModal}
        cancelText={<IntlMessages id="action.cancel" />}
      >
        <Row>
          <Input
            placeholder={`Facility Name`}
            value={name}
            onChange={this.onNameChange}
          />
        </Row>
        {
          error && <Row><p>{`${error}`}</p></Row>
        }
      </Modal>
    );
  }
};

function mapStateToProps(state) {
  const { accounts } = state.Accounts;
  return {
    accounts,
  };
};

const mapActionToProps = {
  addAccount,
};

export default connect(mapStateToProps, mapActionToProps)(AddAccountModal);
